import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(landing)/alternative/opificio-42-coworking/page.client.tsx");
